import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { noWait } from "recoil";

export const BASE = {
    path: `${ptlEnvs.base}/elctdoc/trmssn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/trmssns`,
};

export const URLS = {
    ptli0702001q: `${BASE.path}/ptli0702001q`,
    ptli0702002s: `${BASE.path}/ptli0702002s`,
    ptli0702003q: `${BASE.path}/ptli0702003q`,
};

export const APIS = {
    // Get a list of transmission electronic documents. !== 전자문서 발신 목록을 조회한다. ==!
    getElctDocTrmssnList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select transmission electronic documents details !== 전자문서 발신 상세 정보 조회 ==!
    getElctDocTrmssn: (docNtcUuid: any) => {
        return api.get(`${BASE.api}/${docNtcUuid}`);
    },
    // Update sending electronic documents !== 전자문서 발신 수정 ==!
    updateElctDocTrmssn: (data: any) => {
        console.log("call");
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Select transmission electronic documents history details !== 전자문서 발신 이력 정보 조회 ==!
    getElctDocTrmssnDtl: (trscLogId: any) => {
        return api.get(`${BASE.api}/hists/${trscLogId}`);
    },
    // Get a list of Receive electronic documents. !== 전자문서 수신 목록을 조회한다. ==!
    getResdHistList: (data: any, page: number, size: number) => {
        return api.post(
            `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/elctdoc/rcpns/resdHist?page=${page}&size=${size}`,
            {
                ...data,
            },
        );
    },
};

export const SF_DOC_TRMSSN_MGMT_SRCH: TFormSchema = {
    id: "form_docTrmssnMgmtSrch",
    schema: {
        /* Search keyword Select Option !== 검색어 목록 ==!*/
        // sndrcvTpCd: {
        //     type: "select",
        //     label: "L_SNDRCV_TP_NM",
        //     all: true,
        //     area: "comnCd",
        //     comnCd: "COM0070",
        // },

        /* Search keyword Select Option !== 검색어 목록 ==!*/
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            area: "comnCd",
            comnCd: "COM0024",
            required: false,
        },

        /* Search keyword Select Option !== 검색어 목록 ==!*/
        kwdSel: {
            type: "select",
            label: "L_KWD",
            options: [
                { label: "L_DOC_SBMT_NO", value: "A" },
                { label: "L_INTF_ID", value: "B" },
                { label: "L_SNDR_ID", value: "C" },
                { label: "L_RCVR_ID", value: "D" },
                { label: "L_USR_DEFN_VAL", value: "E" },
                { label: "L_UCR_NO", value: "F" },
            ],
        },
        /* Search keyword Select Option Name !== 검색어 ==!*/
        kwdTxt: {
            type: "text",
            readOnly: true,
        },
        startTimeRnge: {
            type: "daterange",
            label: "L_RGSR_DT",
            start: { name: "startFrstRgsrDtm" },
            end: { name: "endFrstRgsrDtm" },
            rangeButton: 4,
        },
        elctPrcssStatCd: {
            type: "select",
            label: "L_ELCT_PRCSS_STAT",
            all: true,
            area: "comnCd",
            comnCd: "COM0081",
        },
    },
};

// 발신 목록
export const SG_DOC_TRMSSN_MGMT_LIST: TGridSchema = {
    id: "grid_docTrmssnMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_DOC_NTC_ID", binding: "docNtcUuid", width: "18%" }] },
        { cells: [{ header: "L_DCLA_DOC_CD", binding: "dclaDocCd", width: "*" }] },
        { cells: [{ header: "L_DOC_SBMT_NO", binding: "docSbmtNo", width: "*" }] },
        { cells: [{ header: "L_INTF_ID", binding: "intfId", width: "*" }] },
        { cells: [{ header: "L_SNDR_ID", binding: "intfSndrId", width: "*" }] },
        { cells: [{ header: "L_RCVR_ID", binding: "intfRcvrId", width: "*" }] },
        { cells: [{ header: "L_UCR_NO", binding: "ucrNo", width: "*" }] },
        { cells: [{ header: "L_USR_DEFN_VAL", binding: "usrDefnVldVal1", width: "13%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
        { cells: [{ header: "L_ELCT_PRCSS_STAT", binding: "elctPrcssStatCdNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "docNtcUuid" }] },
        { cells: [{ binding: "dclaDocCd" }] },
        { cells: [{ binding: "docSbmtNo" }] },
        { cells: [{ binding: "intfId" }] },
        { cells: [{ binding: "intfSndrId" }] },
        { cells: [{ binding: "intfRcvrId" }] },
        { cells: [{ binding: "ucrNo", align: "left" }] },
        { cells: [{ binding: "usrDefnVldVal1" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
        { cells: [{ binding: "elctPrcssStatCdNm" }] },
    ],
};

// 발신 상세
export const SF_DOC_TRMSSN_DTL_INFO: TFormSchema = {
    id: "form_docTrmssnMgmtInfo",
    schema: {
        trscLogId: { type: "text", label: "L_TRSC_LOG_ID", required: true },
        docNtcUuid: { type: "text", label: "L_TRSC_LOG_ID", required: true },
        dclaDocCd: { type: "text", label: "L_DCLA_DOC_CD", required: true },
        docSbmtNo: { type: "text", label: "L_DOC_SBMT_NO", required: true },
        intfId: { type: "text", label: "L_INTF_ID" },
        intfSndrId: { type: "text", label: "L_SNDR_ID" },
        intfRcvrId: { type: "text", label: "L_RCVR_ID" },
        intfChnlId: { type: "text", label: "L_INTF_CHNL_ID" },
        elctPrcssStatCd: { type: "text", label: "L_ELCT_PRCSS_STAT" },
        elctPrcssStatCdNm: { type: "text", label: "L_ELCT_PRCSS_STAT" },
        usrDefnVldVal1: { type: "text", label: "L_USR_DEFN_VLD_VAL1" },
        usrDefnVldVal2: { type: "text", label: "L_USR_DEFN_VLD_VAL2" },
        usrDefnVldVal3: { type: "text", label: "L_USR_DEFN_VLD_VAL3" },
        usrDefnVldVal4: { type: "text", label: "L_USR_DEFN_VLD_VAL4" },
        usrDefnVldVal5: { type: "text", label: "L_USR_DEFN_VLD_VAL5" },
        sysmSavePathNm: { type: "text", label: "L_SYSM_SAVE_PATH_NM" },
        sysmSaveFileNm: { type: "text", label: "L_SYSM_SAVE_FILE_NM" },
        docNtcDtm: { type: "date", label: "L_DOC_NTC_DTM" },
    },
};

// 이력 상세
export const SF_DOC_TRMSSN_MGMT_INFO: TFormSchema = {
    id: "form_docTrmssnMgmtInfo",
    schema: {
        trscLogId: { type: "text", label: "L_TRSC_LOG_ID", readOnly: true },
        intfId: { type: "text", label: "L_INTF_ID", readOnly: true },
        trscId: { type: "text", label: "L_TRSC_ID", readOnly: true },
        intfSndrId: { type: "text", label: "L_SNDR_ID", readOnly: true },
        intfRcvrId: { type: "text", label: "L_RCVR_ID", readOnly: true },
        coReffNo: { type: "text", label: "L_REFF_NO", readOnly: true },
        ucrNo: { type: "text", label: "L_UCR_NO", readOnly: true },
        intfSttsCd: { type: "text", label: "L_PRCSS_STAT", readOnly: true },
        intfSttsCdNm: { type: "text", label: "L_PRCSS_STAT", readOnly: true },
        frstRgsrDtm: { type: "datetime", label: "L_FRST_RGSR_DTM", readOnly: true },
        intfRsltErrCn: { type: "textarea", label: "L_ERR_MSG_CN" },
        htphdCn: { type: "textarea", label: "L_HTPHD_CN" },
        msgOrgnCn: { type: "textarea", label: "L_MSG_ORGN_CN" },
        msgAckCn: { type: "textarea", label: "L_MSG_ACK_CN" },
    },
};
